module.exports = __webpack_public_path__ + "img/1106a_6.28ab9cea.jpg";